import { useWindowSize } from '@leedpulse-monorepo/hooks';
import { Flex, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { billingIntervalAsSuffix, creditTypeAsString, ECreditType } from '@leedpulse-monorepo/enums';
import { advancedOnRow } from '../../../core/utils/commonUtils';
import { PLANS_PAGE_PATH } from '../../pages/plans/PlansPage';

interface PlansListProps {
  plans: Record<string, any>[];
  loading: boolean;
  page: number;
  nbHits: number;
  hitsPerPage: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (newPageSize: number) => void;
}

const PlansList: React.FC<PlansListProps> = ({ plans, loading, page, nbHits, hitsPerPage, onPageChange, onPageSizeChange }) => {
  const windowSize = useWindowSize();
  const navigate = useNavigate();

  const handlePageSizeChange = (_current: number, newPageSize: number) => {
    onPageSizeChange?.(newPageSize);
  };

  return (
    <Table
      pagination={{
        current: page + 1,
        total: nbHits,
        pageSize: hitsPerPage,
        onChange: (p) => onPageChange(p - 1),
        onShowSizeChange: (_current, newSize) => handlePageSizeChange(_current, newSize),
        showSizeChanger: true,
        simple: true,
        pageSizeOptions: [20, 50, 100, 200],
        position: ['bottomRight', 'topRight'],
        disabled: loading,
      }}
      loading={loading}
      columns={
        windowSize.width > 576
          ? [
            {
              title: 'Nom',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Prix',
              dataIndex: 'price',
              key: 'price',
              // The amount alone says nothing: 539 EUR is a month or a year
              render: (price) => `${price?.formatted ?? ''}${price?.interval ? billingIntervalAsSuffix(price.interval) : ''}`,
            },
            {
              title: 'Récurrent',
              dataIndex: 'recurrence',
              key: 'recurrence',
              render: (recurrence) => recurrence ? 'Oui' : 'Non',
            },
            {
              title: 'Reset des crédits',
              dataIndex: 'recurrence_credits_reset',
              key: 'recurrence_credits_reset',
              render: (recurrence) => recurrence ? 'Oui' : 'Non',
            },
            {
              title: 'Archivé',
              dataIndex: 'archived',
              key: 'archived',
              render: (archived) => archived ? 'Oui' : 'Non',
            },
            {
              title: 'Crédits',
              dataIndex: 'credits',
              key: 'credits',
              render: (credits) =>
                <Flex vertical>
                  {Object.entries(credits ?? {}).sort((a, b) => b[0].localeCompare(a[0])).map(([key, value]) => (
                    <Flex key={key} gap={8} align="center">
                      <span title={creditTypeAsString(key as ECreditType, false)}>{creditTypeAsString(key as ECreditType)}</span>
                      <span>{value as number}</span>
                    </Flex>
                  ))}
                </Flex>,
            },
          ]
          : [
            {
              title: 'Nom',
              dataIndex: 'name',
              key: 'name',
            },
          ]
      }
      rowKey={(record) => record.objectID ?? record.id}
      dataSource={plans}
      onRow={(record) =>
        advancedOnRow({
          url: `${PLANS_PAGE_PATH}/${record.id}`,
          navigate,
          className: 'table-row',
        })
      }
    />
  );
};

export default PlansList;
